const passkey_sign_in = {
    setup_page: {
        title: 'Simplify your sign-in',
        subtitle: 'Create a passkey',
        description: 'Register your passkey using device biometrics, security keys like YubiKey, or other available methods.',
    },
    trigger_conditional_ui_failed: 'Unable to start passkey autofill. Choose Sign in with passkey instead.',
};
export default Object.freeze(passkey_sign_in);
